import React, { memo, useState } from 'react';
import moment from 'moment/moment';

import CaseIcon from '@mui/icons-material/AssignmentOutlined';

import notificationIconNew from '../../assets/notification_icon_new.svg';
import activityIconNew from '../../assets/activity_icon_new.svg';
import notificationIcon from '../../assets/notification_icon.svg';
import activityIcon from '../../assets/activity_icon.svg';

import { utils } from '../../util';

const ActivityMobileItem = ({ activity, onCaseOpen, onDelete, users = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCaseOpen = (caseId) => {
    onCaseOpen(caseId);
    handleClose();
  };

  const handleDelete = (activityId) => {
    onDelete(activityId);
    handleClose();
  };

  const getUserName = (uid) => {
    const user = users?.find((u) => u.uid === uid);
    return user ? ` | ${user.firstName} ${user.lastName}` : '';
  };

  const formattedId = activity?.caseId?.includes("_") ? activity?.caseId?.substring(0, activity?.caseId?.indexOf("_")) : activity.caseId;

  return (
    <div className='p-md' style={{ borderTop: '1px solid #f2f2f2' }}>
      <div className='d-flex'>
        <div className="activity-icon">
          {utils.checkTimeDiff(activity.date) < 24 ? (
            <img
              src={activity.type === 'notification' ? notificationIconNew : activityIconNew}
              alt="activity-icon-new"
            />
          ) : (
            <img
              src={activity.type === 'notification' ? notificationIcon : activityIcon}
              alt="activity-icon"
            />
          )}
        </div>
        <div className="activity-title font-bold">{activity.title}</div>
      </div>
      <div className="m-t-sm secondary">
        {`${moment(activity.date).format('MMM Do YY')} | ${moment(activity.date).format('HH:mm')}${getUserName(activity.userId)}`}
      </div>
      <div className='m-t-sm'>{activity.text}</div>
      <div
        className="m-t-md activity-date"
        onClick={() => handleCaseOpen(activity.caseId)}
      >
        <div className="d-flex primary pointer">
          <CaseIcon />
          <span className='m-l-md'>{formattedId}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(ActivityMobileItem);
